<template>
  <div class="rounded-lg">
    <div
      class="price-text mt-2 mb-1"
    >
      <Price
        v-if="!isOwned || isPrintFormat"
        :book-price="Number(price)"
        :base-currency="currencyId"
        :add-tax="!vatIncluded"
        :should-round="true"
        :is-owned="isOwned && !isPrintFormat"
        :skip-base-rounding="vatIncluded || false"
      />
    </div>
    <add-to-library-button
      v-if="price == 0 && !isOwned && showCartButton"
      :product-id="noIriId"
      :query-loading="isOwnedLoading"
      block
      :show-icon="false"
      :refetch-bookshelf="refetchBookshelf"
      short-text
    />
    <AddToCartButton
      v-else-if="!isOwned && showCartButton && !isPrintFormat"
      :id="id"
      :book="book"
      :simplified-id="noIriId"
      :query-loading="isOwnedLoading"
      block
    />
  </div>
</template>

<script>
import Price from "@/components/Price";
import AddToCartButton from "@/views/checkout/AddToCartButton.vue";
import AddToLibraryButton from "@/components/AddToLibraryButton.vue";
import { isPrintFormat as isPrintFormatHelper } from "@/utils/BookFormatHelper";

export default {
  components: {
    Price,
    AddToCartButton,
    AddToLibraryButton,
  },
  props: {
    book: {
      type: Object,
      required: true,
    },
    price: {
      type: Number,
      default: null,
    },
    currencyId: {
      type: String,
      default: null,
    },
    isOwned: {
      type: Boolean,
      default: false,
    },
    isOwnedLoading: {
      type: Boolean,
      default: false,
    },
    id: {
      type: String,
      default: null,
    },
    noIriId: {
      type: String,
      default: null,
    },
    showCartButton: {
      type: Boolean,
      default: true,
    },
    refetchBookshelf: {
      type: Function,
      default: () => {},
    },
    vatIncluded: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    isPrintFormat() {
      return isPrintFormatHelper(this.book?.format);
    },
  },
};
</script>
